import { h } from 'preact';

import Loadable from 'react-loadable';

export default Loadable({
    loader: () => import('../../../../q-cars/src/containers/BikeCarYard/bikeCarYard.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        let BikeCarYard = loaded.default;
        return <BikeCarYard {...props} />;
    }
});



// WEBPACK FOOTER //
// ../q-cars/src/containers/BikeCarYard/index.js